import type { JSX, ParentComponent } from "solid-js";
import { HStack } from "./Stack";

export const PanelFooter: ParentComponent<{ style?: JSX.CSSProperties }> = (
	props,
) => {
	return (
		<HStack
			class="gvtui-panel-footer"
			justify="end"
			style={props.style}
			spacing="medium"
		>
			{props.children}
		</HStack>
	);
};
